module.exports = __webpack_public_path__ + "img/market-analysis.8918485f.svg";